import { QueryClient } from 'react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

export default queryClient

export const TLDS_CACHE_TIME = 1000 * 60
export const TLDS_QUERY_KEY = 'tlds'
